import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-pulse",
  templateUrl: "./med-icon-pulse.component.html",
})
export class MedIconPulseComponent extends SvgMixinComponent {}
